module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00017-fs8.8b8b3e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00017-fs8.png
// module id = 170
// module chunks = 0